import { Injectable, inject } from '@angular/core';
import { WindowRef } from 'src/app/services/windowref.service';

@Injectable()
export class ConfigurationService {
  private windowRef = inject(WindowRef);

  private readonly vanAckenApiUrl: string;

  constructor() {
    this.vanAckenApiUrl = this.windowRef.nativeWindow.location.origin + '/api';
  }

  get mailUrl(): string {
    return this.vanAckenApiUrl + '/mail';
  }
}
